var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mx-0 flex-nowrap caption",attrs:{"justify":"space-between"}},[_c('v-col',{attrs:{"cols":_vm.mainColCount,"align-self":"center"}},[_c('a-truncate',{attrs:{"text":_vm.supplierName,"hoverText":_vm.hoverText}})],1),(_vm.hasBreakfast)?_c('v-col',{attrs:{"cols":"1"}},[_c('Breakfast')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }